import ExamInformationForm, {
  ExaminationInformationFormProps,
  ExaminationInformationFormInput,
} from './ExaminationInformationForm';
import ExaminationInformationLoading from './ExaminationInformationLoading';

export { ExaminationInformationLoading };
export type { ExaminationInformationFormProps, ExaminationInformationFormInput };
export default ExamInformationForm;
